var map = {
	"./01_Invertebres_sous_marins.mp3": 625,
	"./02_Corb.wav": 712,
	"./03_merou.wav": 891,
	"./04_langouste.wav": 219,
	"./06_rorqual_commun_chant_acc10.wav": 633,
	"./07_famiille06_poisson_1s.wav": 269,
	"./07_famiille09_poisson_5s.wav": 903,
	"./07_famiille16_poisson_10s.wav": 919,
	"./08_herbier_prado_60s.wav": 254,
	"./09_coralligene_2.wav": 64,
	"./10_GEOPHONIE_VAGUES.mp3": 412,
	"./11_Tonnerre_et_PluieForte.wav": 59,
	"./12_glace_1.wav": 573,
	"./12_glace_3.WAV": 836,
	"./13_jet_ski.wav": 313,
	"./13_navire_gros_40s.wav": 143,
	"./13_navire_petit_60s.wav": 363,
	"./13_tanker1.wav": 725,
	"./14_tir_sismique.WAV": 745,
	"./cachalot.wav": 598,
	"./dauphins.wav": 717,
	"./rorqual.wav": 297,
	"./son-1.wav": 541,
	"./son-2.wav": 674,
	"./son-3.wav": 323,
	"./son-4.wav": 565,
	"./son-5.wav": 224,
	"./son-6.wav": 304
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 339;